import * as messages from './errorMessages';

export const REQUIRED = field => {
  if (field === 0 || field) {
    return null;
  }
  return messages.REQUIRED;
};

export const REQUIRED_EMAIL = field => {
  if (field) {
    return null;
  }
  return messages.LOGIN_EMAIL_REQUIRED;
};

export const REQUIRED_PASSWORD = field => {
  if (field) {
    return null;
  }
  return messages.LOGIN_PASSWORD_REQUIRED;
};

export const PASSWORD_MATCH = (field, fields) => {
  if (field === fields.password) {
    return null;
  }
  return messages.MUST_MATCH;
};

export const EMAIL_MATCH = (field, fields) => {
  if (field === fields.email) {
    return null;
  }
  return messages.MUST_MATCH;
};

export const VALID_EMAIL = field => {
  if (field && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(field)) {
    return messages.INVALID_VALUE;
  }
  return null;
};

export const VALID_PHONE = field => {
  const phoneRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
  if (field && !phoneRegex.test(field)) {
    return messages.INVALID_VALUE;
  }
  return null;
};

export const VALID_NUMBER = field => {
  const numberRegex = /^\d+$/;
  if (field && !numberRegex.test(field)) {
    return messages.INVALID_VALUE;
  }
  return null;
};



// WEBPACK FOOTER //
// ./src/helpers/validations.js